export enum PrintTypes {
  None,
  Bet,
  Win,
  Jackpot,
}
